export default __webpack_public_path__ + "static/media/onro-logotype-dark@2x.5f9cfa9f.webp";